<template>
  <div id="app" class="h100">

    <main-menu v-if="user.name" />

    <router-view/>

    <trial-expired-modal />

    <recorder v-if="should_record" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import MainMenu from './components/main-menu'
  import TrialExpiredModal from './components/TrialExpiredModal'
  import Recorder from './components/Recorder.vue'

  // Routes where the session is recorded. Anything not listed here is NOT
  // recorded — keep this list tight, each entry costs storage and is a PII
  // surface on BE. `deviz` matches /deviz/:id (the interior view), NOT the
  // /devize list page.
  const RECORDED_ROUTES = ['deviz', 'cars-data']

  export default {
    name: 'app',
    computed: {
      ...mapState({
        user: state => state.auth.user
      }),
      should_record () {
        return !!this.user.name && RECORDED_ROUTES.indexOf(this.$route.name) !== -1
      }
    },
    components: {
      MainMenu,
      TrialExpiredModal,
      Recorder
    }
  }
</script>

<style lang="less">

</style>
